module.exports = __webpack_public_path__ + "img/one.7a1df6f3.svg";